import React, {EventHandler} from 'react';
import {CurrencyField} from "./CurrencyInput";


export type CurrencyRangeInputArgs = {
  name: string,
  value: string,
  onChange: EventHandler<any>,
  className: string
}

/*

Used in search windows, value is a string in the form of [value in pence]-[value in pence]

e.g.
£5-£10 => 500-1000

 */

export default function CurrencyRangeInput(props:CurrencyRangeInputArgs): React.ReactNode {
  console.log('CURRENCYRANGE',props);
  function changeA(evt:React.ChangeEvent<HTMLInputElement>) {
    const val = (evt.currentTarget??evt.target)?.value;
    const value = (props.value?props.value:'').split('-');
    const values = val+'-'+(value[1]?value[1]:'');
    console.log('changeA',val,value,values);
    props.onChange({target:{name:props.name,value:values},currentTarget:{name:props.name,value:values}});
  }
  function changeB(evt:React.ChangeEvent<HTMLInputElement>) {
    const val = (evt.currentTarget??evt.target)?.value;
    const value = (props.value?props.value:'').split('-');
    const values = (value[0]?value[0]:'')+'-'+val;
    console.log('changeB',val,value,values);
    props.onChange({target:{name:props.name,value:values},currentTarget:{name:props.name,value:values}});
  }
  const values =props.value.split('-');
  return (
    <span className={['currency-range-input',props.className??'','grid12'].join(' ')}>
      <CurrencyField className="grid12-6" error={null} label="From" value={values[0]?values[0]:''} onChange={changeA} placeholder="from" name="from"/>
      <CurrencyField className="grid12-6" error={null} label="To" value={values[1]?values[1]:''} onChange={changeB} placeholder="to" name="to"/>
    </span>);
}
